export async function installNWQuiz() {
  const { NWQuizApp } = await import("./");
  return NWQuizApp;
}
